// File: src/pages/PrivacyPage.jsx
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export default function PrivacyPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const role = searchParams.get('role'); // Lấy role từ URL

  const handleBack = () => {
    if (role === 'business') navigate('/register-business');
    else if (role === 'candidate') navigate('/register-candidate');
    else navigate(-1); // Mặc định quay lại trang trước
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-28 pb-12 px-4 sm:px-6 lg:px-8 font-sans text-gray-800">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-2xl overflow-hidden">
        
        {/* --- HEADER --- */}
        <div className="bg-gradient-to-r from-green-600 to-teal-700 px-8 py-12 text-center text-white relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
            <div className="relative z-10">
                <div className="w-16 h-16 bg-white/20 rounded-2xl mx-auto flex items-center justify-center mb-4 backdrop-blur-sm">
                    <span className="material-symbols-outlined text-4xl text-white">security</span>
                </div>
                <h1 className="text-3xl md:text-4xl font-extrabold mb-2 tracking-tight">Chính sách bảo mật</h1>
                <p className="text-green-100 font-medium">Cam kết bảo vệ dữ liệu người dùng SkillMatch</p>
            </div>
        </div>

        {/* --- CONTENT BODY --- */}
        <div className="p-8 md:p-12 space-y-10">
            <div className="text-sm text-gray-600 leading-relaxed border-l-4 border-green-500 pl-4 bg-green-50 py-3 rounded-r-lg">
                Tại <strong>SkillMatch</strong>, chúng tôi coi trọng sự riêng tư của bạn. Chính sách này giải thích cách chúng tôi thu thập, sử dụng và bảo vệ thông tin cá nhân của bạn.
            </div>

            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-4">1. Dữ liệu chúng tôi thu thập</h2>
                <ul className="list-disc pl-5 space-y-2 text-gray-600 text-sm">
                    <li><strong>Thông tin định danh:</strong> Tên, Email, Số điện thoại, Ảnh đại diện (từ Google/Facebook).</li>
                    <li><strong>Hồ sơ nghề nghiệp:</strong> CV, Kinh nghiệm làm việc, Kỹ năng chuyên môn.</li>
                    <li><strong>Dữ liệu bài kiểm tra (Assessment):</strong>
                        <ul className="list-circle pl-5 mt-1 text-gray-500">
                            <li>Kết quả bài thi, thời gian làm bài.</li>
                            <li>Hình ảnh Webcam và Âm thanh (chỉ thu thập trong quá trình làm bài thi để chống gian lận).</li>
                            <li>Hành vi trình duyệt (rời tab, copy/paste) trong lúc thi.</li>
                        </ul>
                    </li>
                </ul>
            </section>

            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-4">2. Cách chúng tôi sử dụng dữ liệu</h2>
                <p className="text-gray-600 text-sm mb-2">Dữ liệu của bạn được sử dụng để:</p>
                <ul className="list-disc pl-5 space-y-2 text-gray-600 text-sm">
                    <li>Kết nối ứng viên với nhà tuyển dụng phù hợp (AI Matching).</li>
                    <li>Xác minh danh tính và đảm bảo tính công bằng trong các bài kiểm tra năng lực.</li>
                    <li>Gửi thông báo về việc làm mới hoặc ứng viên tiềm năng.</li>
                </ul>
            </section>

            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-4">3. Chia sẻ thông tin</h2>
                <p className="text-gray-600 text-sm">Chúng tôi <strong>không bán</strong> dữ liệu của bạn cho bên thứ ba. Thông tin của bạn chỉ được hiển thị cho:</p>
                <ul className="list-disc pl-5 mt-2 space-y-2 text-gray-600 text-sm">
                    <li><strong>Nhà tuyển dụng:</strong> Khi bạn nộp đơn hoặc khi hồ sơ của bạn ở chế độ "Công khai".</li>
                    <li><strong>Ứng viên:</strong> Xem thông tin cơ bản của Doanh nghiệp khi tìm việc.</li>
                </ul>
            </section>
        </div>

        {/* --- FOOTER ACTIONS --- */}
        <div className="bg-gray-50 px-8 py-6 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-gray-500">
                Thắc mắc về quyền riêng tư? <a href="mailto:skillmatchvn@gmail.com" className="text-green-600 hover:underline">skillmatchvn@gmail.com</a>
            </p>
            <div className="flex gap-3 w-full md:w-auto">
                <button 
                    onClick={handleBack}
                    className="flex-1 md:flex-none px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
                >
                    Quay lại {role === 'business' ? 'Đăng ký DN' : (role === 'candidate' ? 'Đăng ký UV' : '')}
                </button>
            </div>
        </div>

      </div>
    </div>
  );
}